<template>
	<div class="container-careers">
		<ja-dropdown
			v-if="isCreateNew"
			v-model="clustersOptionsIndex"
			:label="$t('clusters')"
			:options="dataClustersOptions"
			name="educationRequired"
		></ja-dropdown>
		<ja-input
			v-if="!isCreateNew"
			v-model="dataClusterName"
			disabled
			:label="$t('clusters')"
			:name="$t('clusters')"
		></ja-input>
		<ja-input
			v-model="careersData.name"
			:disabled="!isCreateNew"
			:label="$t('careerName')"
			:name="$t('careerName')"
		></ja-input>
		<ja-textarea
			v-model="careersData.description"
			:max-length="500"
			:label="$t('description')"
			:name="$t('description')"
		></ja-textarea>
		<ja-dropdown
			v-model="educationRequiredIndex"
			:label="$t('educationRequired')"
			:options="careersData.educationTypes"
			name="educationRequired"
		></ja-dropdown>
		<ja-textarea
			v-model="careersData.education"
			:max-length="500"
			:label="$t('educationDescription')"
			:name="$t('educationDescription')"
		></ja-textarea>
		<ja-textarea
			v-model="careersData.expectedDuties"
			:max-length="500"
			:label="$t('expectedDuties')"
			:name="$t('expectedDuties')"
		></ja-textarea>
		<div>
			<ja-job-titles-table
				v-if="!isCreateNew"
				:data="dataEdit"
			></ja-job-titles-table>
		</div>
		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="!isSaveCareer"
				@click.native="saveCareers"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
			<ja-button
				v-if="!isCreateNew"
				name="cancel"
				class="small"
				@click.native="openDeleteModal"
				>{{ $t('delete') }}</ja-button
			>
		</div>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteCareer()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: $t('career')
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import ConfirmModal from '@/components/Modal/ConfirmModal';
import Dropdown from '@/components/ui/form/Dropdown';
import Textarea from '@/components/ui/form/Textarea';
import Input from '@/components/ui/form/Input';
import JobTitlesTable from './JobTitlesTable.vue';
import Button from '@/components/ui/Button';
import { ID_NEW_CMS } from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaJobTitlesTable: JobTitlesTable,
		jaConfirmModal: ConfirmModal,
		jaDropdown: Dropdown,
		jaTextarea: Textarea,
		jaButton: Button,
		jaInput: Input
	},
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		},
		dataClusterName: {
			type: String,
			default: '',
			required: false
		},
		dataClustersOptions: {
			type: Array,
			default: () => [],
			required: false
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			careersData: null,
			educationRequiredIndex: 0,
			clustersOptionsIndex: 0,
			careerName: '',
			selectedAll: false,
			isCreateNew: false
		};
	},
	computed: {
		isSaveCareer() {
			return (
				this.careersData.name !== null &&
				this.careersData.description !== null &&
				this.careersData.education !== null &&
				this.careersData.expectedDuties !== null &&
				this.careersData.education_ID !== null
			);
		}
	},
	watch: {
		clustersOptionsIndex(newIndex) {
			this.careersData.careerCluster_ID = this.dataClustersOptions[
				newIndex
			].careerCluster_ID;
		},
		educationRequiredIndex(newIndex) {
			this.careersData.education_ID = newIndex;
		}
	},
	created() {
		this.careersData = this.dataEdit;
		this.setInitialIndexes();
		this.careersData.careerCluster_ID = this.dataClustersOptions[0].careerCluster_ID;
		if (this.careersData.career_ID === ID_NEW_CMS) {
			this.isCreateNew = true;
		}
	},
	methods: {
		setInitialIndexes() {
			if (this.careersData.education_ID !== null) {
				this.educationRequiredIndex = this.careersData.educationTypes.findIndex(
					type => type.education_ID === this.careersData.education_ID
				);
			} else {
				this.careersData.education_ID = this.educationRequiredIndex;
			}
		},
		saveCareers() {
			this.careersData.cmsCareerJobTitles = [];
			this.careersData.clusters = [];
			this.careersData.outlook = '';
			this.$emit('saveCareer', this.careersData);
		},
		openDeleteModal() {
			this.showMessageDeletionModal = true;
		},
		deleteCareer() {
			this.$emit('deleteCareer', this.careersData.career_ID);
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-careers {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
.questions {
	justify-content: flex-start;
}
.save {
	justify-content: flex-end;
}
</style>
